// Shared decision logic for handling HTTP error statuses in the axios
// interceptors. Both the global axios instance (auth) and the dedicated
// `@/http` instance use this so that 401/403 behave consistently.

// Clears all zmk_-prefixed keys (session/token) from localStorage.
export function clear_session_storage() {
    Object.keys(localStorage)
        .filter(key => key.startsWith('zmk_'))
        .forEach(key => localStorage.removeItem(key))
}

// Returns the action to take for a given HTTP error status.
//   { type: 'login' }             – clear the session and redirect to login
//   { type: 'session-expired' }   – token expired (show the re-login modal)
//   { type: 'error', statusCode } – redirect to the error page (e.g. 403)
//   { type: 'reject' }            – pass the error through to the caller
export function resolve_error_action(status, { isLoggedIn, isOnLoginPage, isTokenExpired }) {
    if (status === 401) {
        // Unauthenticated. On the login page the error is shown inline,
        // everywhere else the session is cleared and the user is redirected.
        return isOnLoginPage ? { type: 'reject' } : { type: 'login' }
    }

    if (status === 403) {
        // On the login page a 403 means invalid credentials -> show inline.
        if (isOnLoginPage) {
            return { type: 'reject' }
        }
        // Logged in with an expired token -> show the re-login modal.
        if (isLoggedIn && isTokenExpired) {
            return { type: 'session-expired' }
        }
        // Authenticated but not allowed -> dedicated error page.
        if (isLoggedIn) {
            return { type: 'error', statusCode: 403 }
        }
        // Not authenticated -> treat like a lost session.
        return { type: 'login' }
    }

    return { type: 'reject' }
}
